module.exports = __webpack_public_path__ + "06ac34836860c6e8537057a6cd767bfc.svg";